import * as L from "leaflet";

const cacheURL = "https://cache.dciwx.com/";

function makeBasemapsLayer(name: string, minZoom: number, maxNativeZoom: number) {
	return L.tileLayer(`${cacheURL}basemaps/dci/${name}/{z}/{x}/{y}.png`, {
		minZoom,
		maxNativeZoom,
		tms: true,
		detectRetina: true,
	});
}

function makeOpenStreetMapLayer(minZoom: number, maxNativeZoom: number) {
	return L.tileLayer(`https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png`, {
		minZoom,
		maxNativeZoom,
		attribution: "&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a>"
	});
}

// export const globalBaseLayer = makeBasemapsLayer("global", 0, 11);
export const globalBaseLayer = makeOpenStreetMapLayer(2, 17);
// export const globalGPBaseLayer = makeYarmouthBasemapsLayer("https://pilotosm00160617.blob.core.windows.net/pilotosm00160617/", 2, 18),
export const usEnrouteHighLayer = makeBasemapsLayer("enroute-high", 1, 11);
export const usEnrouteLowLayer = makeBasemapsLayer("enroute-low", 1, 11);
export const usSectionalsLayer = makeBasemapsLayer("sectionals", 1, 11);
export const citiesOverlayLayer = makeBasemapsLayer("cities", 2, 11);

interface BaseLayers {
	[key: string]: L.TileLayer;
}

export const baseLayers: BaseLayers = {
	"OpenStreetMap": globalBaseLayer,
	// "Garmin Pilot": globalGPBaseLayer,
	"IFR High (CARIB, U.S.)": usEnrouteHighLayer,
	"IFR Low (CARIB, U.S.)": usEnrouteLowLayer,
	"VFR (U.S.)": usSectionalsLayer,
};

export const overlayLayers = {
	Cities: citiesOverlayLayer,
};
